export default __webpack_public_path__ + "static/media/resume.89cdc7cf.pdf";